export enum MemberType {
  None = 'None',
  Primary = 'Primary',
  Spouse = 'Spouse',
  Dependent = 'Dependent',
}
